import { actionTypes, change as reduxChange } from 'redux-form';

export default store => next => action => {
	// let the action go to the reducers
	next(action);

	if (
		action.type !== actionTypes.CHANGE ||
		!action.meta ||
		action.meta.form !== 'bookingForm'||
		action.meta.field.indexOf('rooms') !== 0
	) {
		return;
	}

	const state = store.getState();
	const formValues = state.form.bookingForm.values;
	const rooms = formValues.rooms;

	// Formulář ještě není inicializovaný
	if (!rooms) return;

	// Odstraníme "rooms", rozdělíme podle "][", odstraníme "[" a "]" na začátku a na konci, vytáhneme poslední index
	// a ten převedeme na int
	const metaFieldNameArray = action.meta.field.substr(5).split('][').map(item => item.replace(/[\][]/, ''));
	const thisGuestTypeId = parseInt(metaFieldNameArray.pop(), 10);
	const reduxChangeFieldName = metaFieldNameArray.map(item => `[${item}]`).join('');

	for (let roomOffer of Object.values(rooms)) {
		for (let room of Object.values(roomOffer)) {
			const maxBeds = room.beds + room.extrabeds;
			let currentBeds = Object.values(room.guestTypes).reduce((accumulator, noOfGuestsOfThisType) => accumulator + noOfGuestsOfThisType, 0);

			if (currentBeds > maxBeds) {
				const guestTypesIds = Object.keys(room.guestTypes).map(key => parseInt(key, 10));
				for (let guestTypeId of guestTypesIds.reverse()) {
					if (guestTypeId === thisGuestTypeId || room.guestTypes[guestTypeId] === 0) {
						continue;
					}
					const newValue = room.guestTypes[guestTypeId] - 1;
					store.dispatch(reduxChange(action.meta.form, `rooms${reduxChangeFieldName}[${guestTypeId}]`, newValue));
					break;
				}
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/store/guestTypesMiddleware.js